import { IFAQItemProps } from './types';
import AFTER_IMAGE_1 from '../assets/after1.svg';
import AFTER_IMAGE_2 from '../assets/after2.svg';
import AFTER_IMAGE_3 from '../assets/after3.svg';
import BEFORE_IMAGE_1 from '../assets/before1.svg';
import BEFORE_IMAGE_2 from '../assets/before2.svg';
import BEFORE_IMAGE_3 from '../assets/before3.svg';

export const FAQ_ITEMS: IFAQItemProps[] = [
  {
    heading: 'Я смогу выселить жильца, если с ним будут проблемы?',
    title: 'Если нарушены условия договора — сможете. Онлайн-договор действует так же, как бумажный.',
    beforeImage: BEFORE_IMAGE_1,
    afterImage: AFTER_IMAGE_1,
    theme: 'item-1',
  },
  {
    heading: 'Я не хочу, чтобы про меня узнала налоговая, что делать?',
    title:
      'По закону вы должны платить налог с дохода от аренды, но онлайн-договор на это не влияет. Мы просто предупреждаем, а подавать документы или нет, решать вам. Кстати, у самозанятых налог всего 4%.',
    beforeImage: BEFORE_IMAGE_2,
    afterImage: AFTER_IMAGE_2,
    theme: 'item-2',
  },
  {
    heading: 'Мой договор попадёт в Росреестр?',
    title: 'Нет, если вы подпишете договор, мы не будем регистрировать его в Росреестре.',
    beforeImage: BEFORE_IMAGE_3,
    afterImage: AFTER_IMAGE_3,
    theme: 'item-3',
  },
];
